// @flow
import React from 'react';
import LocationOsm from './LocationOsm';
import Location from './Location';

type Props = {
  region: ?string,
  city: ?string,
  cityArea: ?string,
  address: ?string,
  geoInfo: {
    geoOsm: ?Array<GeoOsm>,
    numVisibleItems: number,
    postalCode: ?string,
  },
  withRichData?: ?boolean,
};

class LocationContainer extends React.Component<Props> {
  static defaultProps = {
    withRichData: false,
  };

  hasGeoOsm() {
    return this.props.geoInfo.geoOsm && this.props.geoInfo.geoOsm.length;
  }

  render() {
    if (this.hasGeoOsm()) {
      return <LocationOsm geoInfo={this.props.geoInfo} withRichData={this.props.withRichData} />;
    }

    return (
      <Location
        locationData={{
          region: this.props.region,
          city: this.props.city,
          cityArea: this.props.cityArea,
          address: this.props.address,
        }}
        withRichData={this.props.withRichData}
      />
    );
  }
}

export default LocationContainer;



// WEBPACK FOOTER //
// ./app/common/Location/LocationContainer.js